/**
 * Liga os botões `.dbr-produto__nav-arrow` (setas customizadas nas
 * laterais da imagem, settings.show_arrows) à troca de foto — funciona
 * independente das miniaturas estarem visíveis ou ocultas. O
 * `media-gallery.js` do Dawn só liga clique de miniatura -> troca de foto
 * (via classe `is-active` + `display:none` nas outras, ver
 * dbr-produto-info.scss); as setas nativas do Dawn assumem um carrossel
 * que rola (scrollLeft), incompatível com esse esquema de visibilidade —
 * por isso usamos um botão próprio em vez das setas do Dawn.
 */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.dbr-produto__media-card').forEach(function (card) {
    var prevBtn = card.querySelector('.dbr-produto__nav-arrow--prev');
    var nextBtn = card.querySelector('.dbr-produto__nav-arrow--next');
    if (!prevBtn && !nextBtn) return;

    var items = Array.prototype.slice.call(card.querySelectorAll('.product__media-item'));
    if (items.length < 2) return;

    function currentIndex() {
      var index = items.findIndex(function (item) {
        return item.classList.contains('is-active');
      });
      return index === -1 ? 0 : index;
    }

    function activate(index) {
      items.forEach(function (item, i) {
        item.classList.toggle('is-active', i === index);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        activate((currentIndex() + 1) % items.length);
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        activate((currentIndex() - 1 + items.length) % items.length);
      });
    }
  });

  // Dots do "Carrossel mobile" (mobile_thumbnails: carousel) — sincroniza com o
  // slide nativo do Dawn (slider-component), que dispara "slideChanged" tanto no
  // arraste (touch) quanto no clique nas setas nativas (.slider-buttons).
  document.querySelectorAll('.dbr-produto__media-card').forEach(function (card) {
    var dotsWrap = card.querySelector('.dbr-produto__mobile-dots');
    var viewer = card.querySelector('[id^="GalleryViewer-"]');
    if (!dotsWrap || !viewer) return;

    var dots = Array.prototype.slice.call(dotsWrap.querySelectorAll('.dbr-produto__mobile-dot'));

    viewer.addEventListener('slideChanged', function (event) {
      var index = event.detail.currentPage - 1;
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    });

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        if (!viewer.slider) return;
        var slides = viewer.querySelectorAll('[id^="Slide-"]');
        var slide = slides[index];
        if (slide) viewer.slider.scrollTo({ left: slide.offsetLeft });
      });
    });
  });

  // Links âncora (block "Link âncora", ex.: "Ver mais detalhes") rolam
  // suave até o alvo em vez do salto padrão do navegador — escopado só
  // a esse link, sem mexer no scroll-behavior do resto da página.
  document.querySelectorAll('.dbr-produto a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      var target = document.getElementById(link.getAttribute('href').slice(1));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
});
